import axios from "axios";
import config from "@/config/env.config.json";
import logger from "@/utils/logger";
import store from "@/store";
import { DateTime } from "luxon";

const envConfig = config[process.env.NODE_ENV];
const consumerBaseUrl = envConfig.consumerApiBaseUrl;
const wordleApi = {};

// Wordle Words
wordleApi.getWordleWordOfTheDay = async () => {
  let response = null;
  // grab the latest date from latestReading
  try {
    await store.dispatch("getLatestReadingsForDevice");
    if (store.state.isLatestReadingToday) {
      const today = DateTime.now().toLocal().toFormat("yyyy-MM-dd");
      response = await axios.get(
        `${consumerBaseUrl}/patient_portal/wordle_words?use_date=${today}`
      );
      return response.data.data[0];
    } else {
      return response;
    }
  } catch (error) {
    logger.error(error);
    throw error;
  }
};

wordleApi.getAllWordleWords = async () => {
  try {
    const response = await axios.get(
      `${consumerBaseUrl}/patient_portal/wordle_words`
    );
    return response.data;
  } catch (error) {
    logger.error(error);
    throw error;
  }
};

// Wordle Games
wordleApi.createWordleGame = async (body) => {
  try {
    const response = await axios.post(
      `${consumerBaseUrl}/patient_portal/user_profiles/${body.patient_user_profile_id}/wordle_games`,
      body
    );
    return response.data;
  } catch (error) {
    logger.error(error);
    throw error;
  }
};
wordleApi.updateWordleGame = async (body) => {
  try {
    const response = await axios.put(
      `${consumerBaseUrl}/patient_portal/user_profiles/${body.patient_user_profile_id}/wordle_games?wordle_word_id=${body.wordle_word_id}`,
      body
    );
    return response.data;
  } catch (error) {
    logger.error(error);
    throw error;
  }
};
wordleApi.getWordleGameRecord = async (patientUserProfileId, wordleWordId) => {
  try {
    const queryParams =
      wordleWordId !== undefined ? `?wordle_word_id=${wordleWordId}` : "";
    const url = `${consumerBaseUrl}/patient_portal/user_profiles/${patientUserProfileId}/wordle_games${queryParams}`;

    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    logger.error(error);
    throw error;
  }
};

// Wordle Game Attempts
wordleApi.saveWordForRow = async (userProfileId, body) => {
  try {
    const response = await axios.post(
      `${consumerBaseUrl}/patient_portal/user_profiles/${userProfileId}/wordle_games/${store.state.wordleGameId}/wordle_game_attempts`,
      body
    );
    return response.data;
  } catch (error) {
    logger.error(error);
    throw error;
  }
};

wordleApi.getAllGuessedWords = async (userProfileId, wordleGameId) => {
  try {
    const response = await axios.get(
      `${consumerBaseUrl}/patient_portal/user_profiles/${userProfileId}/wordle_games/${wordleGameId}/wordle_game_attempts`
    );
    return response.data;
  } catch (error) {
    logger.error(error);
    throw error;
  }
};

export default wordleApi;
